import ReactFramageElement from "./reactFramage";
import ReactFramageSliceElement from "./reactFramageSlice";

customElements.define("react-framage", ReactFramageElement);
customElements.define("react-framage-slice", ReactFramageSliceElement);

export { ReactFramageElement, ReactFramageSliceElement };
